class APIS {
	apis() {
		return {
			getLabels: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/labels'
			},
			createLabel: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/create/label'
			},
			updateLabel: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/update/label'
			},
			deleteLabel: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/delete/label'
			},
			addUserToLabel: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/label/user'
			},
			removeLabelFromUser: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/label/remove'
			},
			getLabelUsers: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/label/conversations'
			}
		};
	}
}

export default new APIS();